module.exports = __webpack_public_path__ + "img/platform.bce97b8f.png";